<a
  [routerLink]="helperService.getReferenceRouterLink(reference)"
  *ngIf="isReferenceType"
  class="btn btn-primary btn-xs"
>
  <i class="far fa-eye" aria-hidden="true"></i> {{ 'action.view' | translate }}
</a>
